import { inject } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	CanActivateFn,
	Router,
	RouterStateSnapshot
} from "@angular/router";

export const asaasLoginGuardFn: CanActivateFn = (
	route: ActivatedRouteSnapshot,
	_: RouterStateSnapshot
) => {
	const router = inject(Router);
	if (route.queryParamMap.get("x-api-key")) {
		return router.parseUrl(
			`/pages/auth/asaas-login?x-api-key=${
				route.queryParamMap.get("x-api-key") ?? ""
			}`
		);
	}
	return true;
};
